import clsx from "clsx";
import shape from "../../assets/img/shapes/bee-shape-01.webp";


const BeeShape01 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-bee-shape-01", props.className)}>
            <img src={shape} alt="rmdr-bee-shape-01" loading="lazy" width={107} height={107} />
        </div>
    )

}

export default BeeShape01;
